import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { Store } from '@ngrx/store';
import { IProduct } from '@cemex-core/cmx-api';
import { OneClickLoadUnitsBuilderAction } from '../../actions/one-click-units.actions';

@Injectable()
export class OneClickLoadProductUnits implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: IProduct, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store.dispatch(new OneClickLoadUnitsBuilderAction(value, form.mapItem['index']));
  }
}
